import React, { Component } from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent'; // eslint-disable-line no-restricted-imports
import ReactTimeout from 'react-timeout';
import { FormattedMessage } from 'react-intl';
import Pagination from 'components/pagination';
import ErrorTryAgain from 'components/ErrorTryAgain';
import PaneSpinner from 'components/PaneSpinner';
import { Urls, Designers, Pagination as PaginationPropType } from 'apps/find-designers/propTypes';
import DesignerList from './DesignerList';
import ResultsOverview from './ResultsOverview';
import StoreFront from './StoreFront';
import SignUpCta from './SignUpCta';

let scrollToComponent;

class ResultsPane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            designers: this.props.designers,
            pagination: this.props.pagination,
            isLoading: false,
            isFailure: false,
            storeFront: this.props.storeFront,
        };

        this.retry = this.retry.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
    }

    componentDidMount() {
        // https://github.com/component/scroll-to/issues/9#issuecomment-311362354 (same deal, but in mocha)
        scrollToComponent = require('react-scroll-to-component'); // eslint-disable-line
    }

    UNSAFE_componentWillReceiveProps({ searchString }) {
        if (this.props.searchString !== searchString) {
            this.getDesigners(`${this.props.urls.designersXhr}${searchString}`);
        }
    }

    getDesigners(url) {
        this.setState(
            () => ({
                isLoading: true,
            }),
            this.fetchData(url)
        );
    }

    scrollToTop() {
        const duration = 500;
        this.setState({ isScrolling: true }, () => {
            scrollToComponent(this.bodyElement, {
                duration,
                align: 'top',
                offset: -30,
                ease: 'in-out-quart',
            });

            this.props.setTimeout(() => {
                this.setState({ isScrolling: false });
            }, duration);
        });
    }

    fetchData(url) {
        if (this.request) {
            this.request.abort();
        }

        this.request = superagent.get(url).end((err, { body }) => {
            if (err) {
                this.setState(() => ({
                    designers: [],
                    isLoading: false,
                    pagination: [],
                    isFailure: true,
                    storeFront: { show: false },
                }));
            } else {
                this.setState(() => ({
                    designers: body.designers,
                    isLoading: false,
                    pagination: body.pagination,
                    isFailure: false,
                    storeFront: body.storeFront,
                }));
            }
        });
    }

    retry() {
        window.location.reload(true);
    }

    spinner() {
        if (!this.state.isLoading) return null;
        if (this.state.isScrolling) return null;

        const paneRect = this.bodyElement.getBoundingClientRect();

        return (
            <PaneSpinner
                paneTop={paneRect.top}
                viewportHeight={document.documentElement.clientHeight}
                paneHeight={paneRect.height}
            />
        );
    }

    footer() {
        if (!this.props.currentUser.isIdentified) {
            return <SignUpCta signUpCtaUrl={this.props.urls.signUpCtaUrl} />;
        }

        return (
            <div className="results-pane__pagination">
                <Pagination
                    path={this.props.urls.rootPath}
                    currentPage={this.state.pagination.currentPage}
                    totalPages={this.state.pagination.totalPages}
                    searchString={this.props.searchString}
                    onClick={this.scrollToTop}
                />
            </div>
        );
    }

    render() {
        if (this.state.isFailure) {
            return (
                <FormattedMessage id="error_message">
                    {message => <ErrorTryAgain onRetry={this.retry} message={message} />}
                </FormattedMessage>
            );
        }

        if (this.state.storeFront.show === true) {
            return (
                <span
                    ref={element => {
                        this.bodyElement = element;
                    }}
                >
                    {this.spinner()}
                    <StoreFront
                        featuredSearches={this.state.storeFront.featuredSearches}
                        isLoading={this.state.isLoading}
                        onClick={this.scrollToTop}
                    />
                </span>
            );
        }

        return (
            <div className="results-pane">
                <div className="results-pane__overview">
                    <ResultsOverview
                        totalResults={this.state.pagination.totalResults}
                        onClear={this.props.onClear}
                        onReset={this.props.onReset}
                    />
                </div>
                <div
                    className="results-pane__body"
                    ref={element => {
                        this.bodyElement = element;
                    }}
                >
                    {this.spinner()}
                    <DesignerList
                        designers={this.state.designers}
                        isLoading={this.state.isLoading}
                        currentUser={this.props.currentUser}
                    />
                </div>
                {this.footer()}
            </div>
        );
    }
}

ResultsPane.propTypes = {
    urls: Urls.isRequired,
    designers: Designers.isRequired,
    pagination: PaginationPropType.isRequired,
    searchString: PropTypes.string.isRequired,
    setTimeout: PropTypes.func.isRequired,
    storeFront: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        featuredSearches: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                searchUrl: PropTypes.string.isRequired,
                designers: Designers.isRequired,
            })
        ).isRequired,
    }).isRequired,
    onReset: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({
        isIdentified: PropTypes.bool,
    }).isRequired,
};

export default ReactTimeout(ResultsPane);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/ResultsPane.jsx